import { connect } from 'react-redux'
import TeamMemberTablePane from '../../components/team-members/TeamMemberTablePane'
import { actionCreators } from '../../state/actions/team_members'
import { IMemberFilters, IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    currentOrgId: state.organizations.currentOrgId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    updateTeamMemberFilters: (filters: IMemberFilters) => dispatch(actionCreators.updateTeamMemberFilters(filters)),
    resetTeamMemberFilters: () => dispatch(actionCreators.resetTeamMemberFilters())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMemberTablePane)



// WEBPACK FOOTER //
// ./src/containers/team-members/TeamMemberTablePane.ts